var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChartAnnotation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4799 32.3232C7.91945 32.3232 0.979858 25.3837 0.979858 16.8232C0.979858 8.26283 7.91945 1.32324 16.4799 1.32324C25.0403 1.32324 31.9799 8.26283 31.9799 16.8232C31.9799 25.3837 25.0403 32.3232 16.4799 32.3232Z",
    fill: "#F1C04F",
    fillOpacity: 0.1,
    stroke: "#F1C04F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2516 10.4792C11.6892 10.4792 11.1498 10.6992 10.7522 11.0907C10.3545 11.4822 10.1311 12.0133 10.1311 12.5669L10.1311 20.4167C10.1311 20.9704 10.3545 21.5014 10.7522 21.8929C11.1498 22.2845 11.6892 22.5044 12.2516 22.5044L16.9167 22.5044L16.9167 19.2476C16.9167 18.6939 17.1401 18.1629 17.5377 17.7714C17.9354 17.3798 18.4747 17.1599 19.0371 17.1599L22.3451 17.1599L22.3451 12.567C22.3451 12.0133 22.1217 11.4822 21.724 11.0907C21.3263 10.6992 20.787 10.4792 20.2246 10.4792L12.2516 10.4792ZM22.1575 17.995L19.0371 17.995C18.6997 17.995 18.3761 18.1269 18.1375 18.3619C17.8989 18.5968 17.7648 18.9154 17.7648 19.2476L17.7648 22.3197C17.9983 22.2159 18.2108 22.0712 18.3918 21.8928L21.7239 18.6126C21.9051 18.4342 22.052 18.225 22.1575 17.995Z",
    fill: "#F1C04F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartAnnotation);
export default __webpack_public_path__ + "static/media/chart_annotation.74ec6bf3b8250659133aa8444d79c3b1.svg";
export { ForwardRef as ReactComponent };